import { createSlice } from "@reduxjs/toolkit";
import { getClientStats } from "./thunk";

export const initialState = {
  data: null,
  loading: false,
  error: null,
};

const clientStatsSlice = createSlice({
  name: "ClientStatsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getClientStats.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getClientStats.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getClientStats.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error?.message || "Failed to fetch client stats";
    });
  },
});

export default clientStatsSlice.reducer;
